


























































































  import {
    Instance
  } from '@/classes/TayehApi';
import { GetInstanceResponse, GetInvoiceResponse } from '@/classes/TayehApi/Instance';

  import {
    IsCollapseMixin
  } from '@/mixins/UI';
import { Message } from 'element-ui';
import Component, { mixins } from 'vue-class-component';
import { Inject } from 'vue-property-decorator';
  // import Project from '../../components/Project'
  // import axios from 'axios';
  @Component({
    components: {
      'sold-editor': () => import('../components/ShopSoldInvoiceEditor.vue'),
      'bought-editor': () => import('../components/ShopBoughtInvoiceEditor.vue'),
      'cost-editor': () => import('../components/ShopCostInvoiceEditor.vue'),
      'income-editor': () => import('../components/ShopIncomeInvoiceEditor.vue'),
      'rs-editor': () => import('../components/ShopRSInvoiceEditor.vue'),
      'rb-editor': () => import('../components/ShopRBInvoiceEditor.vue'),
      'invoice-viewer': () => import('../components/InvoiceViewer/InvoiceViewer.vue'),
      datePicker: () => import('vue-persian-datetime-picker')
    }
  })

        
    export default class ShopInvoiceEditorUpdateInvoice extends mixins(IsCollapseMixin) {
    instance_id: number = null;
    loading= false;
    page= 1;
    invoice: GetInvoiceResponse= null
    @Inject('getInstance') getInstance: () => GetInstanceResponse;
    PaymentStatus= [{label: 'پرداخت نشده', value: false},{label: 'پرداخت شده', value: true}];
    DeliveryStatus= [{label: 'در انبار', value: 0},{label: 'در حال پردازش', value: 1},{label: 'ارسال شده', value: 2},{label: 'تحویل داده شده', value: 3},{label: 'بازگشتی', value: 4}];
    showPaymentDatePicker = false;
    get invoice_type() {
      return this.invoice?.type||null;
    }
    handleClose() {
      this.$router.back();
    }
    async getInvoice() {
      const res = await Instance.getInvoice(this.instance_id, this.$route.params.invoice_id)
      this.invoice = res.data;
      this.invoice.customer_id = this.invoice.customer?.id;
      this.invoice.transactions.map (t => t.max = t.count);
    }
    async saveStatus () {
      try {
        const res = await Instance.setInvoiceDeliveryPaymentMethod(this.instance_id, this.invoice.id, {
          status: this.invoice.delivery.status,
          datePaid: this.invoice.payment.paid?new Date(this.invoice.payment.date_paid):null
        })
        Message.success('وضعیت با موفقیت ویرایش شد.')
      } catch (err) {
        console.log(err);
        
      }
    }
    created() {
      this.instance_id = this.getInstance().id;
    }
    mounted() {
      this.getInvoice()
    }
  }
